export type StaffAccessLike = {
    member?: boolean | null
    role?: string | null
}

export function canAccessAdminDashboard(staffAccess: StaffAccessLike | null | undefined): boolean {
    return Boolean(staffAccess?.member)
}
